/*
 * @Date: 2024-07-19 12:53:31
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-07-26 10:09:23
 */
import Web3 from "web3";
import { usdtABI } from "@/api/abi/usdtABI";
import { depositABI } from "@/api/abi/depositABI";

class WalletFunc {
  constructor() {
    this.depositContractAddress = "0x2014eAF6C040fcEa42aff6784F5AFD2546b01b2F";
    this.usdtTokenAddress = "0x0C95fD9Df7ad2cCf586A04315266b8Db3C345eE9";
    this.depositAbi = depositABI;
    this.usdtAbi = usdtABI;
    this.web3 = new Web3(window.ethereum);
  }

  checkDeposit = async (address) => {
    try {
      const res = await this.depositContract.methods.getDeposit(address).call();
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  // 充值
  recharge = async (amount, address) => {
    this.depositContract = new this.web3.eth.Contract(
      this.depositAbi,
      this.depositContractAddress
    );
    this.usdtContract = new this.web3.eth.Contract(
      this.usdtAbi,
      this.usdtTokenAddress
    );
    const approveAmount = amount * 10 ** 6;
    await this.usdtContract.methods
      .approve(this.depositContractAddress, approveAmount)
      .send({ from: address });
    await this.depositContract.methods
      .deposit(approveAmount)
      .send({ from: address });
    return await this.checkDeposit(address);
  };
}

export default WalletFunc;
